var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-header-padding ma-0 card-border-bottom"},[_c('TextToSpeech',{attrs:{"voice":_vm.state.coach.voice},on:{"change":_vm.handleAudioChange}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }